import angular from 'angular'
import Papa from 'papaparse'
import './email_management.service'

angular
  .module('admin.email_management', ['admin.email_management.service'])
  .controller('EmailManagementCtrl', EmailManagementCtrl)

/** @ngInject */
function EmailManagementCtrl($stateParams, EmailManagementService) {
  var vm = this
  vm.items = []
  vm.date1 = new Date(new Date().getFullYear(), 0, 1)
  vm.date2 = ''

  vm.openCalendarStart = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenStart = true
  }

  vm.openCalendarEnd = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenEnd = true
  }

  vm.emailTypes = [
    {
      id: '60',
      name: 'New Campaigns',
    },
    {
      id: '61',
      name: 'Streetteam Newsletter',
    },
    {
      id: '14',
      name: 'Marketing Activity',
    },
  ]

  vm.emailType = vm.emailTypes[0].id
  vm.option = 'recipient_email'
  vm.days = 90

  vm.perPage = 25
  vm.sortType = 'ts-desc'
  vm.sortReverse = false

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  vm.selectAll = false
  
  vm.exportFields = [
    { id: 'created_at', name: 'Created At / Joining Date', selected: false },
    { id: 'id', name: 'User ID', selected: false },
    { id: 'name', name: 'Name', selected: false },
    { id: 'username', name: 'Username', selected: false },
    { id: 'email', name: 'Email', selected: false },
    { id: 'phone', name: 'Phone', selected: false },
  ]

  vm.toggleSelectAll = function () {
    angular.forEach(vm.exportFields, function (field) {
      field.selected = vm.selectAll
    })
  }

  vm.checkSelectAll = function () {
    var allSelected = true
    angular.forEach(vm.exportFields, function (field) {
      if (!field.selected) {
        allSelected = false
      }
    })
    vm.selectAll = allSelected
  }

  vm.openExportModal = function () {
    $('#exportModal').modal('show')
  }

  reloadPagination()

  vm.reload = function () {
    reloadPagination()
    vm.load(1)
  }

  vm.load = function (pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }
    if (vm.date1) {
      vm.startDate = moment(vm.date1).unix() + '000000'
    } else {
      vm.startDate = ''
    }
    if (vm.date2) {
      vm.endDate = moment(vm.date2).unix() + '000000'
    } else {
      vm.endDate = ''
    }
    EmailManagementService.list(
      vm.oldPage,
      25,
      vm.emailType,
      vm.option,
      vm.days,
      vm.startDate,
      vm.endDate,
      false,
    ).then(function (result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < result.results.length; i++) {
        result.results[i].ts = new Date(result.results[i].ts / 1000)
      }
      vm.items = result.results
    })
  }

  vm.pageChanged = function (newPage) {
    vm.load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.load(1)

  vm.upload = function () {
    function bouncerParse(val) {
      if (val === 'invalid') {
        return true
      } else if (val === 'disposable') {
        return true
      }

      return false
    }

    Papa.parse(vm.csv, {
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        let data = []
        for (let i = 0; i < results.data.length; i++) {
          data.push({
            email: results.data[i].email,
            user_id: results.data[i].id,
            bounced: bouncerParse(results.data[i].email_status),
          })
        }
        EmailManagementService.upload(data).then(function () {
          swal('Success', 'Emails uploaded successfully', 'success')
        })
      },
    })
  }

  vm.export = function () {
    const selectedFields = vm.exportFields
      .filter((f) => f.selected)
      .map((f) => f.id)
      .join(',')

    vm.exportLoading = true

    EmailManagementService.list(
      vm.oldPage,
      25,
      vm.emailType,
      vm.option,
      vm.days,
      vm.startDate,
      vm.endDate,
      true,
      selectedFields,
    )
      .then(function (result) {
        vm.exportLoading = false
        $('#exportModal').modal('hide')

      let csv = ''

      // If the API directly returns CSV string, use it. Otherwise, parse the JSON array into CSV.
      if (typeof result === 'string') {
        csv = result.replace(/\{\}\s*$/, '')
      } else if (result && result.results) {
        csv = Papa.unparse(result.results, {
          delimiter: ',',
          newline: '\n',
        })
      } else if (Array.isArray(result)) {
        csv = Papa.unparse(result, {
          delimiter: ',',
          newline: '\n',
        })
      }

      if (!csv) {
        return
      }

      // Formulate custom dynamic filename: [mail_type]_[YYYY-MM-DD].csv
      let typeObj = vm.emailTypes.find(function(item) {
        return String(item.id) === String(vm.emailType);
      });
      let typeName = typeObj ? typeObj.name : 'export';
      let formattedName = typeName.toLowerCase().replace(/\s+/g, '_');
      let dateString = moment().format('YYYY-MM-DD');
      let filename = formattedName + '_' + dateString + '.csv';

      // download csv file in browser
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      var url = window.URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
    .catch(function (error) {
      vm.exportLoading = false
      swal('Error', 'Failed to export CSV. Please try again.', 'error')
    })
  }
}
